import React from 'react';
import ReactModal from 'react-modal';
import NavigationLink, { NavigationLinkProps } from './NavigationLink';
import NavigationToggle from './NavigationToggle';
import './style.scss';

interface NavigationMobileProps {
  links: NavigationLinkProps[];
}

const NavigationMobile: React.FC<NavigationMobileProps> = ({ links }) => {
  const [modalStyle, setModalStyle] = React.useState({});
  const [isNavOpen, setNavOpen] = React.useState(false);
  const toggleRef = React.useRef<any>(null);
  const modalRef = React.useRef<any>(null);

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  React.useLayoutEffect(() => {
    if (!isNavOpen) return;

    const position = toggleRef.current.getBoundingClientRect();
    setModalStyle({
      position: 'absolute',
      top: `${position.top}px`,
      left: `${position.left}px`,
      width: `${position.width}px`,
    });
  }, [isNavOpen]);

  return (
    <>
      <NavigationToggle
        isChecked={isNavOpen}
        onChange={toggleNav}
        inputRef={(e) => {
          toggleRef.current = e;
        }}
      />

      <ReactModal
        isOpen={isNavOpen}
        overlayClassName="m-overlay ckp-navigation__modal__overlay is-active"
        bodyOpenClassName="u-modal-open"
        htmlOpenClassName="u-modal-open"
        className="ckp-navigation__modal"
        onRequestClose={toggleNav}
        contentRef={(e) => {
          modalRef.current = e;
        }}
      >
        <nav className="ckp-m-navigation__wrapper" style={modalStyle}>
          <ul className="ckp-m-navigation">
            <li>
              <NavigationToggle isChecked={true} onChange={toggleNav} />
            </li>
            {links.map((linkProps) => (
              <li className="ckp-m-navigation__item" key={`navigation-${linkProps.href}`}>
                <NavigationLink {...linkProps} onClick={toggleNav} />
              </li>
            ))}
          </ul>
        </nav>
      </ReactModal>
    </>
  );
};

export default NavigationMobile;
